import insightEvent from './insightEvent';

const addedToCartObjectIDs = productCode => {
	insightEvent('addedToCartObjectIDs', {
		objectIDs: [productCode],
	});
};

export default addedToCartObjectIDs;
